import * as CONSTANTS from "../utils/constants/constants";
import axios from "axios";

export interface PlatformBuildInfo {
	system_type: string;
	platform_version?: string;
	platform_build_date?: string;
	platform_build_number?: string;
	platform_release_id?: string;
}

class UtilsService {
	static getAIModels() {
		return CONSTANTS.HOST + "api/utils/ai-models/";
	}
	static getPhysicans() {
		return CONSTANTS.HOST + "api/utils/physicians/";
	}

	static assignPhysician(
		physician_id: string,
		patient_id: string,
		access_token: string
	) {
		return axios
			.patch(
				CONSTANTS.HOST +
					"api/utils/physicians/" +
					physician_id +
					"/patients/" +
					patient_id +
					"/assign-physician/",
				{ physician_id, patient_id },
				{
					headers: { authorization: "Bearer " + access_token },
				}
			)
			.then((response: any) => response)
			.catch((err: any) => {
				console.log(err);
				return err.data;
			});
	}
	static unassignPhysician(
		physician_id: string,
		patient_id: string,
		access_token: string
	) {
		return axios
			.patch(
				CONSTANTS.HOST +
					"api/utils/physicians/" +
					physician_id +
					"/patients/" +
					patient_id +
					"/unassign-physician/",
				{ physician_id, patient_id },
				{
					headers: { authorization: "Bearer " + access_token },
				}
			)
			.then((response: any) => response)
			.catch((err: any) => {
				console.log(err);
				return err.data;
			});
	}
	static getSystemType() {
		return CONSTANTS.HOST + "api/utils/server/type";
	}
	static async getPlatformBuildInfo(access_token: string): Promise<PlatformBuildInfo> {
		const response = await axios.get<PlatformBuildInfo>(this.getSystemType(), {
			headers: { Authorization: `Bearer ${access_token}` },
		});
		return response.data;
	}
}

export default UtilsService;
